// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. USE component-icon/src/svgtoreact.sh TO MODIFY
import React from 'react';
import PropTypes from 'prop-types';

var Collapse = function Collapse(_ref) {
  var className = _ref.className,
      label = _ref.label;
  return (
    /*#__PURE__*/
    React.createElement("svg", {
      className: className,
      "aria-label": label,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16"
    },
    /*#__PURE__*/
    React.createElement("path", {
      d: "M7.19 3.447v3.72H3.46l.99-.99-3.28-3.28 1.72-1.73 3.29 3.28 1-1h.01zM14.83 13.107l-1.72 1.73-3.28-3.28-.99.98h-.01v-3.71h3.73l-1.01 1 3.28 3.28zM11.56 6.167l.99 1H8.84v-3.72l.99.99 3.28-3.27 1.72 1.73-3.27 3.27zM7.18 8.817v3.73l-1-1-3.29 3.29-1.72-1.73 3.29-3.28-1-1v-.01h3.72z"
    }))
  );
};

export default Collapse;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/component-icon/es/reactsvgs/Collapse.js
// module id = 993
// module chunks = 0